export const selectTaskAutomation = (state: DefaultRootState) => state?.taskAutomation || {};
export const selectTaskAutomationVisible = (state: DefaultRootState) => state?.taskAutomation?.visible || false;
export const selectTaskAutomationCurrentAutomation = (state: DefaultRootState) => state?.taskAutomation?.currentAutomation || null;

export const selectTaskAutomationsList = (state: DefaultRootState) => state?.taskAutomation?.list || [];

export const selectTaskAutomationMeta = (state: DefaultRootState) => state?.taskAutomation?.meta || null;
